module.exports = __webpack_public_path__ + "static/media/halloween3.5f7b1af0.webp";